<div class="rd-header">
    <app-date-navigation
        (selectedDateUpdated)="updateSelectedDate()"
        [dateNavigationOptions]="dateNavigationOptions">
    </app-date-navigation>

    <div class="search-container">
        <i class="las la-search search-icon"></i>
        <input type="text" class="form-control search-input" placeholder="Search O&O..." (keyup)="applyFilter($event)" />
    </div>

    <div class="rd-tabs">
        <button type="button" [class.active]="selectedTab === 'projects'" (click)="selectedTab = 'projects'">
            Per project
        </button>
        <button type="button" [class.active]="selectedTab === 'months'" (click)="selectedTab = 'months'">
            Per maand
        </button>
        <button type="button" [class.active]="selectedTab === 'monthProjects'" (click)="selectedTab = 'monthProjects'">
            Maand/project
        </button>
        <button type="button" [class.active]="selectedTab === 'report'" (click)="selectedTab = 'report'">
            Details
        </button>
    </div>

    <div class="rd-actions">
        <button
            type="button"
            class="button button--outline"
            (click)="exportReportCsv()"
            [disabled]="loading || !reportDataSource.filteredData.length">
            <i class="las la-file-csv m-r-1"></i>
            Export CSV
        </button>
        <button
            type="button"
            class="button button--outline"
            (click)="exportReportPdf()"
            [disabled]="loading || !reportDataSource.filteredData.length">
            <i class="las la-file-pdf m-r-1"></i>
            Export PDF
        </button>
    </div>
</div>

<div *ngIf="loading" class="financial-loading-screen m-b-4">
    <div class="financial-loading-screen__inner">
        <app-loading-message></app-loading-message>
        <p class="financial-loading-screen__text">O&amp;O data wordt geladen...</p>
    </div>
</div>

<div class="rd-summary" *ngIf="!loading">
    <div class="box">
        <label class="m-b-1">O&amp;O projects</label>
        <div class="summary-value">{{ projectDataSource.filteredData.length }}</div>
    </div>
    <div class="box">
        <label class="m-b-1">Timesheet hours</label>
        <div class="summary-value">{{ getTotalHours() | number:'1.1-1' }}h</div>
    </div>
    <div class="box">
        <label class="m-b-1">Total cost</label>
        <div class="summary-value">{{ getTotalCost() | currency:'EUR':'symbol':'1.0-0' }}</div>
    </div>
    <div class="box box--highlight">
        <label class="m-b-1">Total O&amp;O</label>
        <div class="summary-value summary-value--primary">{{ getTotalResearchDevelopmentCost() | currency:'EUR':'symbol':'1.0-0' }}</div>
    </div>
</div>

<div class="table__scroll" *ngIf="!loading && selectedTab === 'projects'">
    <table #projectSort="matSort" mat-table matSort [dataSource]="projectDataSource" class="table-view table-view--compact">
        <ng-container matColumnDef="project">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Project</th>
            <td mat-cell *matCellDef="let row">
                <button type="button" class="rd-link" (click)="openProject(row.projectId)">
                    {{ row.projectTitle }}
                </button>
            </td>
        </ng-container>

        <ng-container matColumnDef="percentage">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>O&amp;O %</th>
            <td mat-cell *matCellDef="let row">{{ row.percentage | number:'1.0-2' }}%</td>
        </ng-container>

        <ng-container matColumnDef="totalHours">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Hours</th>
            <td mat-cell *matCellDef="let row">{{ row.totalHours | number:'1.1-1' }}h</td>
        </ng-container>

        <ng-container matColumnDef="timesheetCost">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Timesheets</th>
            <td mat-cell *matCellDef="let row">{{ row.timesheetCost | currency:'EUR':'symbol':'1.0-0' }}</td>
        </ng-container>

        <ng-container matColumnDef="purchaseInvoiceCost">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Aankoopfacturen</th>
            <td mat-cell *matCellDef="let row">{{ row.purchaseInvoiceCost | currency:'EUR':'symbol':'1.0-0' }}</td>
        </ng-container>

        <ng-container matColumnDef="totalCost">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Total cost</th>
            <td mat-cell *matCellDef="let row">{{ row.totalCost | currency:'EUR':'symbol':'1.0-0' }}</td>
        </ng-container>

        <ng-container matColumnDef="researchDevelopmentCost">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>O&amp;O cost</th>
            <td mat-cell *matCellDef="let row">
                <strong>{{ row.researchDevelopmentCost | currency:'EUR':'symbol':'1.0-0' }}</strong>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="projectColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: projectColumns"></tr>
        <tr *matNoDataRow>
            <td [attr.colspan]="projectColumns.length" class="mat-cell rd-empty">Geen O&amp;O projectdata gevonden.</td>
        </tr>
    </table>
    <div class="rd-total-footer">
        <span>Total O&amp;O for {{ selectedYear }}</span>
        <strong>{{ getTotalResearchDevelopmentCost() | currency:'EUR':'symbol':'1.0-0' }}</strong>
    </div>
</div>

<div class="table__scroll" *ngIf="!loading && selectedTab === 'months'">
    <table #monthlySort="matSort" mat-table matSort [dataSource]="monthlyDataSource" class="table-view table-view--compact">
        <ng-container matColumnDef="month">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Maand</th>
            <td mat-cell *matCellDef="let row">{{ row.monthLabel }}</td>
        </ng-container>

        <ng-container matColumnDef="projects">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Projecten</th>
            <td mat-cell *matCellDef="let row">{{ row.projectCount }}</td>
        </ng-container>

        <ng-container matColumnDef="employees">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Medewerkers</th>
            <td mat-cell *matCellDef="let row">{{ row.employeeCount }}</td>
        </ng-container>

        <ng-container matColumnDef="timesheetRows">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Regels</th>
            <td mat-cell *matCellDef="let row">{{ row.timesheetRows }}</td>
        </ng-container>

        <ng-container matColumnDef="totalHours">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Hours</th>
            <td mat-cell *matCellDef="let row">{{ row.totalHours | number:'1.1-2' }}h</td>
        </ng-container>

        <ng-container matColumnDef="timesheetCost">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Timesheets</th>
            <td mat-cell *matCellDef="let row">{{ row.timesheetCost | currency:'EUR':'symbol':'1.0-0' }}</td>
        </ng-container>

        <ng-container matColumnDef="purchaseInvoiceCost">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Aankoopfacturen</th>
            <td mat-cell *matCellDef="let row">{{ row.purchaseInvoiceCost | currency:'EUR':'symbol':'1.0-0' }}</td>
        </ng-container>

        <ng-container matColumnDef="totalCost">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Total cost</th>
            <td mat-cell *matCellDef="let row">{{ row.totalCost | currency:'EUR':'symbol':'1.0-0' }}</td>
        </ng-container>

        <ng-container matColumnDef="researchDevelopmentCost">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>O&amp;O cost</th>
            <td mat-cell *matCellDef="let row">
                <strong>{{ row.researchDevelopmentCost | currency:'EUR':'symbol':'1.0-0' }}</strong>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="monthlyColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: monthlyColumns"></tr>
        <tr *matNoDataRow>
            <td [attr.colspan]="monthlyColumns.length" class="mat-cell rd-empty">Geen O&amp;O maandtotalen gevonden.</td>
        </tr>
    </table>
    <div class="rd-total-footer">
        <span>Total O&amp;O for {{ selectedYear }}</span>
        <strong>{{ getTotalResearchDevelopmentCost() | currency:'EUR':'symbol':'1.0-0' }}</strong>
    </div>
</div>

<div class="table__scroll" *ngIf="!loading && selectedTab === 'monthProjects'">
    <table #monthlyProjectSort="matSort" mat-table matSort [dataSource]="monthlyProjectDataSource" class="table-view table-view--compact">
        <ng-container matColumnDef="month">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Maand</th>
            <td mat-cell *matCellDef="let row">{{ row.monthLabel }}</td>
        </ng-container>

        <ng-container matColumnDef="project">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Project</th>
            <td mat-cell *matCellDef="let row">
                <button type="button" class="rd-link" (click)="openProject(row.projectId)">
                    {{ row.projectTitle }}
                </button>
            </td>
        </ng-container>

        <ng-container matColumnDef="percentage">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>O&amp;O %</th>
            <td mat-cell *matCellDef="let row">{{ row.percentage | number:'1.0-2' }}%</td>
        </ng-container>

        <ng-container matColumnDef="employees">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Medewerkers</th>
            <td mat-cell *matCellDef="let row">{{ row.employeeCount }}</td>
        </ng-container>

        <ng-container matColumnDef="timesheetRows">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Regels</th>
            <td mat-cell *matCellDef="let row">{{ row.timesheetRows }}</td>
        </ng-container>

        <ng-container matColumnDef="totalHours">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Hours</th>
            <td mat-cell *matCellDef="let row">{{ row.totalHours | number:'1.1-2' }}h</td>
        </ng-container>

        <ng-container matColumnDef="timesheetCost">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Timesheets</th>
            <td mat-cell *matCellDef="let row">{{ row.timesheetCost | currency:'EUR':'symbol':'1.0-0' }}</td>
        </ng-container>

        <ng-container matColumnDef="purchaseInvoiceCost">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Aankoopfacturen</th>
            <td mat-cell *matCellDef="let row">{{ row.purchaseInvoiceCost | currency:'EUR':'symbol':'1.0-0' }}</td>
        </ng-container>

        <ng-container matColumnDef="totalCost">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Total cost</th>
            <td mat-cell *matCellDef="let row">{{ row.totalCost | currency:'EUR':'symbol':'1.0-0' }}</td>
        </ng-container>

        <ng-container matColumnDef="researchDevelopmentCost">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>O&amp;O cost</th>
            <td mat-cell *matCellDef="let row">
                <strong>{{ row.researchDevelopmentCost | currency:'EUR':'symbol':'1.0-0' }}</strong>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="monthlyProjectColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: monthlyProjectColumns"></tr>
        <tr *matNoDataRow>
            <td [attr.colspan]="monthlyProjectColumns.length" class="mat-cell rd-empty">Geen O&amp;O maand/project data gevonden.</td>
        </tr>
    </table>
    <div class="rd-total-footer">
        <span>Total O&amp;O for {{ selectedYear }}</span>
        <strong>{{ getTotalResearchDevelopmentCost() | currency:'EUR':'symbol':'1.0-0' }}</strong>
    </div>
</div>

<div class="table__scroll" *ngIf="!loading && selectedTab === 'report'">
    <table #reportSort="matSort" mat-table matSort [dataSource]="reportDataSource" class="table-view table-view--compact">
        <ng-container matColumnDef="period">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Period</th>
            <td mat-cell *matCellDef="let row">{{ row.period | date:'MMM yyyy' }}</td>
        </ng-container>

        <ng-container matColumnDef="project">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Project</th>
            <td mat-cell *matCellDef="let row">
                <button type="button" class="rd-link" (click)="openProject(row.projectId)">
                    {{ row.projectTitle }}
                </button>
            </td>
        </ng-container>

        <ng-container matColumnDef="employee">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Employee</th>
            <td mat-cell *matCellDef="let row">{{ row.employeeName || '-' }}</td>
        </ng-container>

        <ng-container matColumnDef="costType">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
            <td mat-cell *matCellDef="let row">{{ formatCostType(row.costType) }}</td>
        </ng-container>

        <ng-container matColumnDef="invoiceNumber">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Invoice</th>
            <td mat-cell *matCellDef="let row">{{ row.invoiceNumber || '-' }}</td>
        </ng-container>

        <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef>Description</th>
            <td mat-cell *matCellDef="let row">{{ row.description || '-' }}</td>
        </ng-container>

        <ng-container matColumnDef="hours">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Hours</th>
            <td mat-cell *matCellDef="let row">{{ row.hours | number:'1.1-2' }}h</td>
        </ng-container>

        <ng-container matColumnDef="hourlyCost">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Cost/h</th>
            <td mat-cell *matCellDef="let row">{{ row.hourlyCost | currency:'EUR':'symbol':'1.0-0' }}</td>
        </ng-container>

        <ng-container matColumnDef="totalCost">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Total cost</th>
            <td mat-cell *matCellDef="let row">{{ row.totalCost | currency:'EUR':'symbol':'1.0-0' }}</td>
        </ng-container>

        <ng-container matColumnDef="percentage">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>O&amp;O %</th>
            <td mat-cell *matCellDef="let row">{{ row.percentage | number:'1.0-2' }}%</td>
        </ng-container>

        <ng-container matColumnDef="researchDevelopmentCost">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>O&amp;O cost</th>
            <td mat-cell *matCellDef="let row">
                <strong>{{ row.researchDevelopmentCost | currency:'EUR':'symbol':'1.0-0' }}</strong>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="reportColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: reportColumns"></tr>
        <tr *matNoDataRow>
            <td [attr.colspan]="reportColumns.length" class="mat-cell rd-empty">Geen O&amp;O timesheetregels gevonden.</td>
        </tr>
    </table>
    <div class="rd-total-footer">
        <span>Total O&amp;O for {{ selectedYear }}</span>
        <strong>{{ getTotalResearchDevelopmentCost() | currency:'EUR':'symbol':'1.0-0' }}</strong>
    </div>
</div>
